import { useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { shopRedirectsApi } from "./shopRedirectsApi";

export const useShopRedirects = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.SHOP_REDIRECTS(),
    queryFn: () => shopRedirectsApi.fetch(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SHOP_REDIRECTS(),
    });
  };

  return {
    isLoading,
    isFetching,
    redirects: data?.data ?? [],
    invalidate,
  };
};

export const useShopRedirectChains = () => {
  const queryClient = useQueryClient();

  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.SHOP_REDIRECT_CHAINS(),
    queryFn: () => shopRedirectsApi.fetchChains(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SHOP_REDIRECT_CHAINS(),
    });
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SHOP_REDIRECTS(),
    });
  };

  return {
    isLoading,
    chains: data?.data ?? [],
    invalidate,
  };
};
